import { Client } from '@capital-markets-gateway/api-client-rolodex';

import { createApiClientFactory } from './createApiClientFactory';

export const rolodexApiClient = new Client('', createApiClientFactory());
